// TODO: https://1stdibs.atlassian.net/browse/MW-489
export const SECTIONS_BY_TYPE = {
    'RECENT': {
        title: 'Recent Searches',
        urlSection: null
    },
    'POPULAR': {
        title: 'Popular Searches',
        urlSection: null
    },
    'CREATOR': {
        title: 'Creators',
        urlSection: 'creators'
    },
    'STYLE': {
        title: 'Styles',
        urlSection: 'styles'
    },
    'SELLER': {
        title: 'Dealers',
        urlSection: 'dealers'
    }
};

export const getSearchType = type => SECTIONS_BY_TYPE[type] || {};
export const getSearchUrlSection = type => SECTIONS_BY_TYPE[type] || {};

export function createSearchLinkPath({term, urlSection, urlLabel}) {
    const convertedValue = encodeURIComponent(term.toLowerCase());
    const href = urlSection && urlLabel
        ? `/${urlSection}/${urlLabel}/?search=${convertedValue}`
        : `/search/?q=${convertedValue}`;

    return href;
};



// WEBPACK FOOTER //
// ./src/components/MobileNav/MobileNavSearchResults/mobileNavSearchResultsUtils.js